<template>
    <div id="app">
        <controlPanel class="control-panel"></controlPanel>
        <lmap class="map"></lmap>
        <yearControl class="mmap-year-control-content"></yearControl>
        <linfowindow />
        <loading-modal />
    </div>
</template>

<script>
import lmap from './components/Map'
import yearControl from './components/controls/year-control'
import controlPanel from './components/controls/control-panel'
import linfowindow from '@/components/infoWindow'
import loadingModal from '@/components/loadingModal'

import '../static/styles/reset.css'
import '../static/styles/yui.css'

export default {
  name: 'App',
  components:{
    lmap,
    yearControl,
    controlPanel,
    linfowindow,
    loadingModal
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
// .control-panel{
  // position: absolute;
  // z-index: 1;
// }
.map{
  position: absolute;
  z-index: 0;
  height: 100%;
  width: 100%;
}
.mmap-year-control-content{
  position: absolute;
  /* z-index: 5000; */
  bottom: 0px;
  left: calc( calc(100% - 800px) * 0.5 );
}

// div.leaflet-popup div.leaflet-popup-content div.leaflet-popup-content-wrapper {
//   width: 500px;
// }

div.leaflet-popup-content-wrapper {
  height: auto;
  width: 650px;
  background-color: whitesmoke;
}

div.leaflet-popup-content {
  width: 650px;
}

div.leaflet-popup-tip {
  background-color: whitesmoke;
}

.popup{
  position: relative;
  display: flex;
  margin: 0 auto;
  height: auto;
  width: 100%;
  justify-content: space-between;
}

.left-block {
  width: 44%;
  margin: 0px;
}

.right-block {
  width: 50%;
  margin: 0px;
}

table {
	border-collapse: collapse;
}
td {
	// border: solid 1px;
  text-align: right;
	padding-right: 1.0em;
  padding-left: 1.0em;
  padding-top: 0.7em;
  padding-bottom: 0.7em;
}

.column {
  text-align: left;
  font-weight: bold;
}

.popup_title {
  font-size: 20px;
}

.popup_address {
  font-size: 13px;
  padding-bottom: 15px;
  border-bottom: solid 1px;
}

.p10s {
  background-color: gainsboro;
}
.p30s {
  background-color: gainsboro;
}
.p50s {
  background-color: gainsboro;
}
.p70s {
  background-color: gainsboro;
}

.popup-population-wrapper {
  display: flex;
  justify-content: flex-end;
  background-color: white;
  height: 50px;
  width: 100%;
  border: solid 3px;
}

.popup-population-range {
  padding-top: 20px;
  padding-left: 10px;
  width: 100;
}

.popup-population-total {
  text-align: right;
  padding: 8px .5em 0 1em;
  font-size: 25px;
  color: 	mediumorchid;
  font-weight: bold;
}

</style>
